import './Broker.scss';
import Component from './Broker.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
